import { render, staticRenderFns } from "./CreateAssessmentRough.vue?vue&type=template&id=c4782ba4&scoped=true&"
import script from "./CreateAssessmentRough.vue?vue&type=script&lang=js&"
export * from "./CreateAssessmentRough.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssessmentRough.vue?vue&type=style&index=0&id=c4782ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4782ba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VSelect,VTextField,VTextarea})
